import React from 'react';

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hour: '', minute: '', meridian: ''};
  }

  render() {
    const onChange = this.onComponentChange.bind(this);

    return (
      <div className="form-inline">
        <Component name="hour" onChange={onChange}>
          <option value="" hidden>Hour</option>
          {this.renderHourOptions()}
        </Component>
        <Component name="minute" onChange={onChange}>
          <option value="" hidden>Minute</option>
          {this.renderMinuteOptions()}
        </Component>
        <Component name="meridian" onChange={onChange}>
          <option value="" hidden>AM/PM</option>
          <option>AM</option>
          <option>PM</option>
        </Component>
      </div>
    );
  }

  renderHourOptions() {
    return _.map(_.range(1, 13), hour => {
      return <option>{this.pad(hour)}</option>;
    });
  }

  renderMinuteOptions() {
    return _.map(_.range(0, 12), increment => {
      return <option>{this.pad(increment * 5)}</option>;
    });
  }

  pad(value) {
    return value < 10 ? `0${value}` : value;
  }

  onComponentChange(name, value) {
    this.setState({[name]: value}, this.detectChange.bind(this));
  }

  detectChange() {
    const value = this.calculateValue();

    if (value !== this.getValue()) {
      this.props.onChange(value);
    }
  }

  getValue() {
    return this.props.value || null;
  }

  calculateValue() {
    if (!this.isValid()) return null;
    var timeString = this.state.hour + ':' + this.state.minute + this.state.meridian;
    var time = moment(timeString,'hh:mmA')
    var value = time.format('HH:mm');
    return value;
  }

  isValid() {
    return !!this.state.hour && !!this.state.minute && !!this.state.meridian;
  }
}

class Component extends React.Component {
  render() {
    return (
      <div className="form-group" style={{marginRight: 5}}>
        <select
          className="form-control"
          onChange={this.onChange.bind(this)}
        >
          {this.props.children}
        </select>
      </div>
    );    
  }

  onChange(event) {
    this.props.onChange(this.props.name, event.target.value);
  }
}